import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { GetPartnerStatisticsInput, GetPartnerStatisticsResponse } from '../types/partnerStatistics';

const GET_PARTNER_STATISTICS = gql`
  query GetPartnerStatistics($input: GetPartnerStatisticsInput!) {
    getPartnerStatistics(input: $input) {
      averageEarningsPerDelivery
      cancelledDeliveries
      completedDeliveries
      completionRate
      totalDeliveries
      totalDeliveryFees
      totalEarnings
      totalTips
      dailyTrend {
        date
        deliveryCount
        totalEarnings
      }
      topPartners {
        averageEarningsPerDelivery
        cancelledDeliveries
        completedDeliveries
        completionRate
        partnerId
        partnerName
        totalDeliveries
        totalDeliveryFees
        totalEarnings
        totalTips
      }
      topStoresByPartner {
        averageOrderValue
        orderCount
        storeId
        storeName
        storeNameAr
        totalRevenue
      }
    }
  }
`;

export function usePartnerStatistics(input?: GetPartnerStatisticsInput) {
  // Provide default values to ensure input is always defined
  const defaultInput: GetPartnerStatisticsInput = {
    startDate: null,
    endDate: null,
    partnerId: null,
    storeId: null,
  };

  const queryInput = input || defaultInput;

  return useQuery<GetPartnerStatisticsResponse, { input: GetPartnerStatisticsInput }>(
    GET_PARTNER_STATISTICS,
    {
      variables: { input: queryInput },
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
    }
  );
}
